import React, { useState } from 'react'
import SectionCard from '../shared/SectionCard'
import { FileUploadField } from '../shared'
import { translate } from '@/utils/langUtils'
import { CRIcon } from '@/components/crRender'
import './style.css'
const APIURL = window.API_URL

const EditGalleryImgs = ({ formHandler, providerInfo }) => {

    const { formValues, handleFormValues } = formHandler
    const [imgs, setImages] = useState(providerInfo?.files?.findFirstValue('name', 'GalleryImgs')?.data || [])


    console.log(imgs)

    const deleteGalleryImg = (value) => {
        let DeletedImgs = formValues.deletedFiles || []

        handleFormValues("deletedFiles", [...DeletedImgs, value])
    }


    const updateGalleryImgs = (value) => {
        handleFormValues("GalleryImgs", {
            value: value,
            isRequired: false,
            isError: false
        })
    }


    return (
        <SectionCard
            title={translate("gallery-images")}
            icon="streamline-plump-color:gallery-2-flat"
            className="edit-gallery-imgs"
        >
            <div className='gallery-imgs-container'>
                {imgs.filter(img => !formValues?.deletedFiles?.includes(img.id)).map((img) => (
                    <div key={img.name} className='gallery-img-container'>
                        <img src={`${APIURL}${img.name}`} alt={img.name} className='gallery-img' />
                        <button className='gallery-img-overlay-button' onClick={() => deleteGalleryImg(img.id)}>
                            <CRIcon icon="mdi:trash-can-outline" className='gallery-img-overlay-button-icon' />
                        </button>
                    </div>
                ))}

            </div>

            <FileUploadField
                className="col-lg-12"
                formHandler={(name, value) => updateGalleryImgs(value)}
                name="GalleryImgs"
                id={`gallery-imgs`}
                accept="image/*"
                multiple={true}
                maxFiles={50}
            />

        </SectionCard>
    )
}

export default EditGalleryImgs